var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"online"},[_c('shop-online',{key:_vm._column.id,attrs:{"online":_vm._column.onLineList},on:{"openForceDialog":_vm.openForceDialog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }